import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=556729c4&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&lang=css&"
import style2 from "./DashboardLayout.vue?vue&type=style&index=2&id=556729c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556729c4",
  null
  
)

export default component.exports